import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=12999400&scoped=true&"
import script from "./JobForm.vue?vue&type=script&lang=ts&"
export * from "./JobForm.vue?vue&type=script&lang=ts&"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=12999400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12999400",
  null
  
)

component.options.__file = "JobForm.vue"
export default component.exports